// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M7.57181 21C8.90661 20.3598 10.41 20 12 20C13.59 20 15.0934 20.3598 16.4282 21M6.8 17H17.2C18.8802 17 19.7202 17 20.362 16.673C20.9265 16.3854 21.3854 15.9265 21.673 15.362C22 14.7202 22 13.8802 22 12.2V7.8C22 6.11984 22 5.27976 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3H6.8C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8V12.2C2 13.8802 2 14.7202 2.32698 15.362C2.6146 15.9265 3.07354 16.3854 3.63803 16.673C4.27976 17 5.11984 17 6.8 17ZM10.9744 13.2905L14.9173 10.7558C15.2656 10.5319 15.4398 10.4199 15.5 10.2775C15.5526 10.1531 15.5526 10.0127 15.5 9.88829C15.4398 9.7459 15.2656 9.63392 14.9173 9.40996L10.9744 6.87529C10.573 6.61719 10.3722 6.48814 10.2062 6.5C10.0615 6.51033 9.9285 6.58297 9.84158 6.69907C9.74184 6.8323 9.74184 7.07094 9.74184 7.54823V12.6176C9.74184 13.0949 9.74184 13.3335 9.84158 13.4667C9.9285 13.5828 10.0615 13.6555 10.2062 13.6658C10.3722 13.6776 10.573 13.5486 10.9744 13.2905Z"
    />
  </svg>
);
const IconMonitorPlay = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconMonitorPlay;
